import { createContext } from "react";

const DataStore = createContext();

export default DataStore;
